import css from "styled-jsx/css";
import colors from "/styles/colors";

import { MOBILE_QUERY_MAX_WIDTH, TABLET_QUERY_MAX_WIDTH, MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH } from "constants/vp-sizes";

export default css`
  .footer-bottom-bar-component {
    position: relative;
    font-size: 14px;
    color: ${colors["brand-gray"]};
    display: flex;
    align-items: center;
    padding: 0 32px;

    .items-container {
      max-width: ${MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH + "px"};
      width: 100%;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      border-top: 1px solid;
      border-top-color: ${colors["border-gray"]};
      padding: 24px;
      align-items: center;

      .links-container {
        display: flex;

        .short-footer-link-component-wrapper {
          display: flex;

          &:not(:last-child) {
            margin-right: 40px;
          }
        }
        .accessibility-statement-link-wrapper {
          margin-right: 40px;
        }

        .language-picker-wrapper {
          position: relative;
          top: -7px;
        }
      }
    }

    .made-with-love-sentence {
      padding-top: 5px;
      :global(.red-heart) {
        height: 12px;
      }
    }
  }

  @media (max-width: ${TABLET_QUERY_MAX_WIDTH}) and (min-width: ${MOBILE_QUERY_MAX_WIDTH}) {
    .footer-bottom-bar-component {
      .items-container {
        padding: 0 54px;
      }
    }
  }

  @media (max-width: ${MOBILE_QUERY_MAX_WIDTH}) {
    .footer-bottom-bar-component {
      .made-with-love-sentence {
        display: none;
      }
    }
  }
`;
